import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { Language } from '@lemon8/web-app-shared/i18n';
import { $Locale } from '@lemon8/web-app-shared/atom';
import { IImageMeta } from '~/assets';

import GP_EN from './google-play/en.png';
import GP_ID from './google-play/id.png';
import GP_JA from './google-play/ja.png';
import GP_MS from './google-play/ms.png';
import GP_TH from './google-play/th.png';
import GP_VI from './google-play/vi.png';

import APPLE_EN from './app-store/en.png';
import APPLE_ID from './app-store/id.png';
import APPLE_JA from './app-store/ja.png';
import APPLE_MS from './app-store/ms.png';
import APPLE_TH from './app-store/th.png';
import APPLE_VI from './app-store/vi.png';

import APK_EN from './apk/en.png';
import APK_ID from './apk/id.png';
import APK_JA from './apk/ja.png';
import APK_MS from './apk/ms.png';
import APK_TH from './apk/th.png';
import APK_VI from './apk/vi.png';

const GP_DOWNLOAD_BUTTON_MAP: { [key in Language]: string } = {
  [Language.en]: GP_EN,
  [Language.id]: GP_ID,
  [Language.ja]: GP_JA,
  [Language.ms]: GP_MS,
  [Language.th]: GP_TH,
  [Language.vi]: GP_VI,
  [Language.fil]: GP_EN,
  [Language.fr]: GP_EN,
};

const APK_DOWNLOAD_BUTTON_MAP: { [key in Language]: string } = {
  [Language.en]: APK_EN,
  [Language.id]: APK_ID,
  [Language.ja]: APK_JA,
  [Language.ms]: APK_MS,
  [Language.th]: APK_TH,
  [Language.vi]: APK_VI,
  [Language.fil]: APK_EN,
  [Language.fr]: APK_EN,
};

const APPLE_DOWNLOAD_BUTTON_MAP: { [key in Language]: string } = {
  [Language.en]: APPLE_EN,
  [Language.id]: APPLE_ID,
  [Language.ja]: APPLE_JA,
  [Language.ms]: APPLE_MS,
  [Language.th]: APPLE_TH,
  [Language.vi]: APPLE_VI,
  [Language.fil]: APPLE_EN,
  [Language.fr]: APPLE_EN,
};

export const usePlatformDownloadButton = (platform: 'Android' | 'iOS' | 'APK'): IImageMeta => {
  const { language } = useAtomValue($Locale);
  const { t } = useTranslation();

  if (platform === 'APK') {
    return {
      src: APK_DOWNLOAD_BUTTON_MAP[language],
      alt: t('web_download_googlePlay'),
    };
  }

  return {
    src: (platform === 'Android' ? GP_DOWNLOAD_BUTTON_MAP : APPLE_DOWNLOAD_BUTTON_MAP)[language],
    alt: platform === 'Android' ? t('web_download_googlePlay') : t('web_download_appStore'),
  };
};
